export default {
      id: "icon-trainingthicker-usage",
      viewBox: "0 0 125 104",
      url: __webpack_public_path__ + "icons.svg#icon-trainingthicker",
      toString: function () {
        return this.url;
      }
    }